import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
  Avatar,
  IconButton,
  styled,
} from "@mui/material";
import {
  Close as CloseIcon,
} from "@mui/icons-material";
import { StyledButton } from "./StyledComponents";

const AdCard = styled(Card)(({ theme }) => ({
  background: 'url(./get.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: 16,
  boxShadow: '0 2px 8px #eee',
  marginBottom: 16,
  minHeight: 180,
  maxWidth: 320,
  overflow: 'hidden',
  '& .MuiCardContent-root': {
    padding: 20,
    color: '#fff',
  },
}));

const CompareCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  marginBottom: 16,
  border: '1px solid #e0e0e0',
  background: '#fff',
  '& .MuiCardContent-root': {
    padding: 16,
  },
}));

const AlertCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: '0 2px 8px #eee',
  marginBottom: 16,
  '& .MuiCardContent-root': {
    padding: 20,
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
}));

function RightSidebar() {
  return (
    <Box sx={{ width: 340, minWidth: 300, marginLeft: 3 }}>
      {/* Expedia Ad */}
      <AdCard>
        <CardContent>
          <Typography variant="h5" sx={{ fontWeight: 700, fontSize: 22, color: '#fff', marginBottom: 1 }}>
            Expedia
          </Typography>
          <Typography variant="body1" sx={{ color: '#fff', fontSize: 15 }}>
            Made to Travel
          </Typography>
        </CardContent>
      </AdCard>

      {/* Compare vs. KAYAK */}
      <CompareCard>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 16, marginBottom: 1.5 }}>
            Compare vs. KAYAK
          </Typography>
          <Stack spacing={1}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                height: 32, 
                width: 120, 
                borderRadius: 1, 
                border: '1px solid #e0e0e0',
                background: '#fff',
                padding: '6px 10px',
                flex: 1
              }}>
                <Avatar 
                  src="https://www.kayak.com/picasso/svg?url=/kimg/a/suppliers/3001309/vector-logos/123c97fada18b760.svg&padX=5&padY=5&bgColor=%230068ef"
                  sx={{ 
                    height: 20, 
                    width: 'auto', 
                    borderRadius: 0,
                    padding: 0,
                    objectFit: 'contain',
                    maxWidth: 100
                  }}
                />
              </Box>
              <StyledButton 
                variant="outlined" 
                sx={{ 
                  flex: 1, 
                  background: '#e9edf0', 
                  border: 'none',
                  height: 32,
                  fontSize: '13px',
                  '&:hover': {
                    background: '#d9dde0',
                    border: 'none',
                  }
                }}
              >
                Compare
              </StyledButton>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                height: 32, 
                width: 120, 
                borderRadius: 1, 
                border: '1px solid #e0e0e0',
                background: '#fff',
                padding: '6px 10px',
                flex: 1
              }}>
                <Avatar 
                  src="https://www.kayak.com/picasso/svg?url=/kimg/a/suppliers/7002706/vector-logos/308fe5b0f986f556.svg&padX=5&padY=5"
                  sx={{ 
                    height: 20, 
                    width: 'auto', 
                    borderRadius: 0,
                    padding: 0,
                    objectFit: 'contain',
                    maxWidth: 100
                  }}
                />
              </Box>
              <StyledButton 
                variant="outlined" 
                sx={{ 
                  flex: 1, 
                  background: '#e9edf0', 
                  border: 'none',
                  height: 32,
                  fontSize: '13px',
                  '&:hover': {
                    background: '#d9dde0',
                    border: 'none',
                  }
                }}
              >
                Compare
              </StyledButton>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                height: 32, 
                width: 120, 
                borderRadius: 1, 
                border: '1px solid #e0e0e0',
                background: '#fff',
                padding: '6px 10px',
                flex: 1
              }}>
                <Avatar 
                  src="https://www.kayak.com/picasso/svg?url=/kimg/a/suppliers/7002579/vector-logos/ad33a1d568398d44.svg&padX=5&padY=5"
                  sx={{ 
                    height: 20, 
                    width: 'auto', 
                    borderRadius: 0,
                    padding: 0,
                    objectFit: 'contain',
                    maxWidth: 100
                  }}
                />
              </Box>
              <StyledButton 
                variant="outlined" 
                sx={{ 
                  flex: 1, 
                  background: '#e9edf0', 
                  border: 'none',
                  height: 32,
                  fontSize: '13px',
                  '&:hover': {
                    background: '#d9dde0',
                    border: 'none',
                  }
                }}
              >
                Compare
              </StyledButton>
            </Box>
           
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                height: 32, 
                width: 120, 
                borderRadius: 1, 
                border: '1px solid #e0e0e0',
                background: '#fff',
                padding: '6px 10px',
                flex: 1
              }}>
                <Avatar 
                  src="https://www.kayak.com/picasso/svg?url=/kimg/a/suppliers/7002699/vector-logos/1cac3a7e3d285cd5.svg&padX=5&padY=5"
                  sx={{ 
                    height: 20, 
                    width: 'auto', 
                    borderRadius: 0,
                    padding: 0,
                    objectFit: 'contain',
                    maxWidth: 100
                  }}
                />
              </Box>
              <StyledButton 
                variant="outlined" 
                sx={{ 
                  flex: 1, 
                  background: '#e9edf0', 
                  border: 'none',
                  height: 32,
                  fontSize: '13px',
                  '&:hover': {
                    background: '#d9dde0',
                    border: 'none',
                  }
                }}
              >
                Compare
              </StyledButton>
            </Box>
          </Stack>
          <StyledButton
            fullWidth
            variant="contained"
            sx={{ 
              background: '#222', 
              color: '#fff', 
              marginTop: 1.5,
              height: 36,
              fontSize: '13px',
              '&:hover': {
                background: '#333',
              }
            }}
          >
            Compare all
          </StyledButton>
        </CardContent>
      </CompareCard>

      {/* Price Alerts */}
      <AlertCard>
        <CardContent>
          <Avatar sx={{ background: '#ffe6c7', color: '#ff690f', fontSize: 22, fontWeight: 700 }}>
            !
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 16, marginBottom: 0.5 }}>
              Get Price Alerts
            </Typography>
            <Typography variant="body2" sx={{ color: '#888', fontSize: 15, marginBottom: 1 }}>
              Monitor prices and receive email updates when they change.
            </Typography>
            <StyledButton
              variant="outlined"
              sx={{ 
                background: '#e9edf0', 
                color: '#222', 
                border: 'none',
                '&:hover': {
                  background: '#d9dde0',
                  border: 'none',
                }
              }}
            >
              Track prices
            </StyledButton>
          </Box>
          <IconButton 
            size="small" 
            sx={{ 
              background: 'none', 
              border: 'none', 
              fontSize: 22, 
              color: '#888',
              marginLeft: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
        </CardContent>
      </AlertCard>
    </Box>
  );
}

export default RightSidebar;